import { createEntityAdapter } from "@reduxjs/toolkit";
import { createAppSlice } from "../../../shared/lib/store/createAppSlice.js";
import { name } from "../config/name.js";
import { fetchBanks } from "./actions.js";
const adapter = createEntityAdapter({
  selectId: (bank) => bank.id
});
const initialState = adapter.getInitialState();
const slice = createAppSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchBanks.fulfilled, (state, action) => {
      adapter.setAll(state, action.payload);
    });
  }
});
const actions = {
  ...slice.actions
};
const selectors = adapter.getSelectors();
export {
  actions,
  adapter,
  selectors,
  slice
};
